module.exports = __webpack_public_path__ + "img/male_avartar.df517b85.png";